import './maincntr.css'
import Messages from './messages/Messages'
import News from './news/News'
import Profile from './profile/Profile'

import { Provider } from 'react-redux';
import store from './store/store/store'

export default function Maincntr() {
  return (
    <Provider store = {store}>
      <div className='maincntr'>
        <div className='fbcntr'>
            <Profile />
            <News />
            <Messages />
        </div>
      </div>
    </Provider>
  )
}
